import React from 'react'
import Vision from '../../Assets/About/Vision.png'
import Mission from '../../Assets/About/Mission.png'
import Values from '../../Assets/About/Values.png'
const MissionVision = () => {
    return (
        <React.Fragment>
            <div className="md:mx-16 mx-6 mt-10 md:mt-16s md:space-y-10 mb-10">
                {/* Vision Section */}
                <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8" data-aos="fade-down-right">
                    <img src={Vision} alt="Icon representing vision" data-aos="fade-up-left"/>
                    <div data-aos="fade-up-right">
                        <h1 className="text-3xl lg:text-5xl text-blue-600 font-semibold mb-4">Our Vision</h1>
                        <p className="text-gray-600 text-base md:text-md lg:text-xl tracking-wide">
                            To be a leading provider of accurate, reliable, and innovative testing solutions for civil engineering projects. Our laboratory strives to uphold the highest standards of quality, safety, and efficiency, contributing to the advancement of infrastructure development and ensuring sustainable, durable, and resilient construction. Through cutting-edge technology and expert analysis, we aim to support the global civil engineering community in building a stronger, safer, and more sustainable future.
                        </p>
                    </div>
                </div>

                {/* Mission Section */}
                <div className="flex flex-col-reverse md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8">
                    <div  data-aos="fade-up-left">
                        <h2 className="text-3xl lg:text-5xl text-blue-600 font-semibold mb-4">Our Mission</h2>
                        <p className="text-gray-600 text-base md:text-md lg:text-xl tracking-wide">
                            Our mission is to provide accurate, reliable, and timely testing services for civil engineering materials and structures. Through advanced testing methods and state-of-the-art equipment, we ensure the highest standards of quality, safety, and compliance. We aim to support the construction industry by delivering precise data and insights that contribute to durable, sustainable, and safe infrastructure, while adhering to national and international standards.
                        </p>
                    </div>
                    <img  data-aos="fade-up-right" src={Mission} alt="Icon representing mission" />
                </div>

                {/* Values Section */}
                <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8">
                    <img data-aos="fade-up-left" src={Values} alt="Icon representing values" />
                    <div data-aos="fade-down-right">
                        <h2 className="text-3xl lg:text-5xl text-blue-600 font-semibold mb-4">Our Values</h2>
                        <p className="text-gray-600 text-base md:text-md lg:text-xl tracking-wide">
                            Delivering precise and reliable test results. Upholding transparency and ethical standards in all processes. Ensuring a secure environment for staff and equipment. Maintaining high standards in testing methods and reporting. Embracing new technologies for better outcomes. Taking responsibility for results and services. Prioritizing client needs with timely and effective solutions.
                        </p>
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}

export default MissionVision